import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "@app/core";
import { SearchComponent } from "@app/view/jobs/search/search.component";
import { MeetingDetailPageComponent } from "@app/view/jobs/meeting-detail-page/meeting-detail-page.component";
import { VisitDesignerBoardComponent } from "@app/view/visit-designer/visit-designer-board/visit-designer-board.component";

const routes: Routes = [
  {
    path: "jobs",
    component: SearchComponent,
    data: { title: "scheduler.menu.jobs" },
    canActivate: [AuthGuardService]
  },
  {
    path: "jobs/:source/:jobId",
    component: VisitDesignerBoardComponent,
    data: { title: "scheduler.menu.job" },
    canActivate: [AuthGuardService]
  },
  {
    path: "meetings/:source/:id",
    component: MeetingDetailPageComponent,
    data: { title: "scheduler.menu.job" },
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobsRoutingModule {}
